import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function UsersAlert() {
    return (<Alert appearance="danger" icon={<Falcon icon="circle-xmark"/>} message={t({
            message: 'An error occurred when fetching users for your company.',
            comment: 'Error message for fetching users for a company',
        })}/>);
}
